import baseUrl from "./baseUrl";

function customerClub(uuid,profile_id) {
  return {
    method: 'get',
    url: `${baseUrl}/api/v1/profile/subscribers?user_uuid=${uuid}&profile_id=${profile_id}`,
    headers: { 
       'Accept': 'application/json', 
    },
 }

  
}

export default customerClub;
